module.exports = __webpack_public_path__ + "static/img/icon-jtjs.6da488e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-jtjs.svg
// module id = 7bzl
// module chunks = 1